<template>
  <div class="dash-root">
    <vue-element-loading :active="appLoading" spinner="bar-fade-scale" color="#3ea56e" size="128" is-full-screen />
    <v-snackbar v-model="showsnackbar" color="#3ea56e" right>
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right><v-btn small :ripple="false" text @click="showsnackbar = false"><v-icon style="color: white">mdi-close</v-icon></v-btn></v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout v-if="ServerError" wrap justify-center><v-flex px-5 pt-5 xs12 sm12 md12 lg12 xl12 text-center><ServerError /></v-flex></v-layout>

    <div v-if="!ServerError">
      <div class="dash-page-header">
        <div>
          <!-- <p class="dash-page-header__eyebrow">Catalog</p> -->
          <h1 class="dash-page-header__title">Main Categories</h1></div>
        <div class="dash-page-header__actions">
          <v-dialog :retain-focus="false" v-model="dialog" persistent max-width="600px" content-class="modern-dialog" :key="dialog">
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="add-btn" v-bind="attrs" v-on="on" depressed><v-icon left>mdi-plus</v-icon> Add Main Category</v-btn>
            </template>
            <v-card class="form-dialog-card">
              <v-form v-model="addcat" ref="addcat">
                <div class="form-dialog-header"><h3 class="form-dialog-title">Add Main Category</h3></div>
                <v-card-text class="pt-4">
                  <v-container>
                    <v-row>
                      <v-col cols="12"><v-text-field v-model="name" label="Main Category Name" :rules="[rules.required]" required outlined dense></v-text-field></v-col>
                      <v-col cols="12"><v-file-input v-model="categoryImg" @change="getFiles" label="Image" outlined dense></v-file-input></v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
                <v-card-actions class="px-6 pb-6">
                  <v-spacer></v-spacer><v-btn class="btn-cancel" @click="dialogclose()" depressed>Close</v-btn><v-btn class="btn-save" :disabled="!addcat" @click="categoryadd()" depressed>Save</v-btn>
                </v-card-actions>
              </v-form>
            </v-card>
          </v-dialog>
        </div>
      </div>

      <div class="modern-table-card">
        <v-data-table :headers="headers" :items="category" :search="search" hide-default-footer>
          <template v-slot:[`item.icon`]="{ item }">
            <div class="cat-icon-wrapper">
              <img v-if="item.icon" :src="baseURL + '/u/' + item.icon" />
              <img v-else src="../../assets/images/No-Image-Placeholder.svg.png" />
            </div>
          </template>
          <template v-slot:[`item._id`]="{ item }">
            <v-btn icon color="#2e9e60" class="action-btn-edit" @click="editcat(item)" small><v-icon size="18">mdi-pencil</v-icon></v-btn>
            <v-dialog v-model="item.delete" max-width="400px" content-class="modern-dialog">
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon color="#ff4757" class="action-btn-delete" v-on="on" v-bind="attrs" small><v-icon size="18">mdi-delete-outline</v-icon></v-btn>
              </template>
              <v-card class="dialog-card">
                <div class="dialog-icon warning"><v-icon color="#ff4757" size="32">mdi-alert-circle-outline</v-icon></div>
                <h3 class="dialog-title">Delete Main Category?</h3>
                <p class="dialog-subtitle">Are you sure you want to delete this Main Category?</p>
                <div class="dialog-actions"><v-btn class="btn-cancel" @click="item.delete = false" depressed>Cancel</v-btn><v-btn class="btn-confirm" @click="deleteItem(item)" depressed>Delete</v-btn></div>
              </v-card>
            </v-dialog>
          </template>
          <template v-slot:top>
            <v-dialog v-model="editdialog" :retain-focus="false" max-width="600px" content-class="modern-dialog">
              <v-card class="form-dialog-card">
                <div class="form-dialog-header"><h3 class="form-dialog-title">Edit Main Category</h3></div>
                <v-card-text class="pt-4">
                  <v-container>
                    <v-row>
                      <v-col cols="12"><v-text-field v-model="editingitem.name" label="Main Category Name" outlined dense></v-text-field></v-col>
                      <v-col cols="12" class="text-center">
                        <v-img v-if="editingitem.icon" height="150" width="200" contain :src="baseURL + '/u/' + editingitem.icon" style="margin: 0 auto; border-radius: 8px; border: 1px solid #eaedf0;"></v-img>
                        <v-img v-else height="150" width="200" contain src="../../assets/images/No-Image-Placeholder.svg.png" style="margin: 0 auto; border-radius: 8px; border: 1px solid #eaedf0;"></v-img>
                      </v-col>
                      <v-col cols="12"><v-file-input v-model="categoryImg" @change="getFiles" label="Upload New Image" outlined dense></v-file-input></v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
                <v-card-actions class="px-6 pb-6"><v-spacer></v-spacer><v-btn class="btn-cancel" @click="editdialog = false" depressed>Cancel</v-btn><v-btn class="btn-save" @click="edit()" depressed>Save</v-btn></v-card-actions>
              </v-card>
            </v-dialog>
          </template>
        </v-data-table>
        <div class="pt-4 pb-4 d-flex justify-center" v-if="pages > 0">
          <v-pagination v-model="currentPage" :length="pages" :total-visible="7" color="#3ea56e"></v-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      showsnackbar: false,
      ServerError: false,
      msg: null,
      pages: 0,
      dialog: false,
      editdialog: false,
      editingitem: {},
      name: "",
      pageCount: 1,
      appLoading: false,
      editedIndex: -1,
      currentPage: 1,
      perPage: 10,
      totalData: 0,
      totalRows: 0,
      dialogDelete: false,
      search: "",
      itemname: "",
      addcat: false,
      title: null,
      fbpixel: null,
      keywords: [],
      categoryImg: null,
      attachments: null,
      attachmentsformData: new FormData(),
      cId: "",
      headers: [
        { text: "Icon", value: "icon" },
        { text: "Main Category Name", value: "name" },
        { text: "Actions", value: "_id", sortable: false },
      ],
      rules: {
        required: (value) => !!value || "Required.",
        min: (v) => v.length >= 8 || "Min 8 characters",
      },
      category: [],
      data: [],
    };
  },
  watch: {
    currentPage() {
      this.getData();
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    deleteItem(cat) {
      var data = {};
      data["id"] = cat._id;
      axios({
        url: "/maincategory/remove",
        method: "POST",
        data: data,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.delete = false;
          this.appLoading = false;
          if (response.data.status) {
            this.msg = "Delete Sucessfully";
            this.showsnackbar = true;
            this.getData();
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    getData() {
      this.appLoading = true;
      axios({
        url: "/maincategory/getlist",
        method: "GET",
        params: {
          page: this.currentPage,
          count: this.perPage,
        },
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.category = response.data.data;
          this.totalData = response.data.count || (this.category ? this.category.length : 0);
          this.pages = Math.ceil(this.totalData / this.perPage) || 1;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    dialogclose() {
      this.name = null;
      this.dialog = false;
    },
    getFiles() {
      var selectedFiles = this.categoryImg;
      if (this.categoryImg) {
        this.msg = null;
        this.attachments = selectedFiles;
      }
    },
    categoryadd() {
      var data = {};
      data["name"] = this.name;
      axios({
        url: "/maincategory/add",
        method: "POST",
        data: data,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.cId = response.data.id;
            if (this.categoryImg) {
              //   this.attachmentsformData.append("icon", this.attachments);
              this.uploadattachments();
            }
            this.msg = "Added Sucessfully";
            this.showsnackbar = true;
            this.name = null;
            this.dialog = false;
            this.getData();
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    uploadattachments() {
      this.categoryImg = null;
      this.attachmentsformData.append("icon", this.attachments);
      this.attachmentsformData.append("id", this.cId);
      axios({
        method: "POST",
        url: "/maincategory/upload/icon",
        data: this.attachmentsformData,

        headers: {
          "Content-Type": "multipart/form-data",
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.attachmentsformData = new FormData();
            this.msg = "Upload Successfully";
            this.showsnackbar = true;
            var myTimeout = setTimeout(this.getData, 2000);
            console.log(myTimeout);
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    uploadattachments1() {
      this.categoryImg = null;
      this.attachmentsformData.append("icon", this.attachments);
      this.attachmentsformData.append("id", this.editingitem._id);
      axios({
        method: "POST",
        url: "/maincategory/upload/icon",
        data: this.attachmentsformData,
        headers: {
          "Content-Type": "multipart/form-data",
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.attachmentsformData = new FormData();
            this.msg = "Upload Successfully";
            this.showsnackbar = true;
            var myTimeout = setTimeout(this.getData, 2000);
            console.log(myTimeout);
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    editcat(item) {
      this.editingitem = { ...item };
      this.editdialog = true;
    },
    edit() {
      var data = {};
      data["id"] = this.editingitem._id;
      data["name"] = this.editingitem.name;
      axios({
        url: "/maincategory/edit",
        method: "POST",
        data: data,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.editdialog = false;
          this.appLoading = false;
          if (response.data.status) {
            if (this.categoryImg) {
              //   this.attachmentsformData.append("icon", this.attachments);
              this.uploadattachments1();
            }
            this.msg = "Edited Sucessfully";
            this.showsnackbar = true;
            this.getData();
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>
<style scoped>
.dash-root {
  font-family: poppinsmedium, Roboto, sans-serif;
  padding: 12px 12px;
}
.dash-page-header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  margin-bottom: 24px;
  flex-wrap: wrap;
  gap: 16px;
}
.dash-page-header__eyebrow {
  font-size: 13px;
  color: #8a93a4;
  margin: 0 0 4px;
  font-family: poppinsmedium, sans-serif;
}
.dash-page-header__title {
  font-size: 22px;
  font-weight: 700;
  color: #1a202c;
  margin: 0;
  font-family: poppinsbold, sans-serif;
  line-height: 1.2;
}
.modern-table-card {
  background: #ffffff;
  border: 1px solid #eaedf0;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.02);
}
.action-btn-delete {
  background: #fff5f5 !important;
  border: 1px solid #ffe4e6 !important;
  border-radius: 10px;
  transition: all 0.2s ease;
}
.action-btn-delete:hover {
  background: #ffe4e6 !important;
  border-color: #fda4af !important;
  transform: scale(1.05);
}
.action-btn-edit {
  background: #f0fdf4 !important;
  border: 1px solid #dcfce7 !important;
  border-radius: 10px;
  transition: all 0.2s ease;
  margin-right: 8px;
}
.action-btn-edit:hover {
  background: #dcfce7 !important;
  border-color: #86efac !important;
  transform: scale(1.05);
}
.add-btn {
  background-color: #3ea56e !important;
  color: white !important;
  border-radius: 12px;
  text-transform: none;
  font-weight: 600;
  padding: 0 20px !important;
  height: 42px !important;
  box-shadow: 0 4px 12px rgba(62, 165, 110, 0.2) !important;
}
::v-deep .modern-dialog { border-radius: 16px; }
.dialog-card { padding: 24px; text-align: center; border-radius: 16px; }
.dialog-icon { width: 56px; height: 56px; border-radius: 50%; display: flex; align-items: center; justify-content: center; margin: 0 auto 16px; }
.dialog-icon.warning { background: #fff5f5; }
.dialog-title { font-size: 18px; font-weight: 600; color: #1a202c; margin: 0 0 8px; font-family: poppinssemibold, sans-serif; }
.dialog-subtitle { font-size: 13px; color: #8a93a4; margin: 0 0 24px; }
.dialog-actions { display: flex; gap: 12px; justify-content: center; }
.btn-cancel { flex: 1; background: #f1f5f9 !important; color: #475569 !important; border-radius: 8px; text-transform: none; font-weight: 600; box-shadow: none !important; }
.btn-confirm { flex: 1; background: #ff4757 !important; color: #ffffff !important; border-radius: 8px; text-transform: none; font-weight: 600; box-shadow: 0 4px 12px rgba(255, 71, 87, 0.2) !important; }
.btn-save { flex: 1; background: #3ea56e !important; color: #ffffff !important; border-radius: 8px; text-transform: none; font-weight: 600; box-shadow: 0 4px 12px rgba(62, 165, 110, 0.2) !important; }
.form-dialog-card { border-radius: 16px; }
.form-dialog-header { padding: 20px 24px 0; }
.form-dialog-title { font-size: 20px; font-weight: 600; color: #1a202c; font-family: poppinssemibold, sans-serif; }
::v-deep .v-data-table { background: transparent !important; }
::v-deep .v-data-table > .v-data-table__wrapper > table > thead > tr > th { font-family: poppinssemibold, sans-serif; font-size: 13px; color: #8a93a4 !important; text-transform: uppercase; border-bottom: 1px solid #eaedf0 !important; padding: 16px; }
::v-deep .v-data-table > .v-data-table__wrapper > table > tbody > tr > td { padding: 16px; border-bottom: 1px solid #eaedf0 !important; font-family: poppinsmedium, sans-serif; color: #1a202c; }
::v-deep .v-data-table > .v-data-table__wrapper > table > tbody > tr:hover { background-color: #f8fafc !important; }
.cat-icon-wrapper { width: 48px; height: 48px; border-radius: 12px; background: #f1f5f9; display: flex; align-items: center; justify-content: center; overflow: hidden; border: 1px solid #eaedf0; }
.cat-icon-wrapper img { max-width: 100%; max-height: 100%; object-fit: contain; }
</style>
